<template>
  <div id="loggedOut" class="clr3" ref="mainView">

    <div id="nav" v-if="this.loggedIn">
      <div id="navtop">
        <!-- {{info}} -->
      </div>
      <!-- <div id="navmiddle">
        <router-link to="/portfolio">Portfolio</router-link>
        <router-link to="/settings">Settings</router-link>
        <router-link to="/toplist">Top List</router-link>
        <router-link to="/tradingcentre">Trading Centre</router-link>
      </div>
      <div></div>
      <div id="navbottom">
          <p>Logout</p>
      </div> -->
      <div class="container">
        <div class="row">
          <div class="userInfo">
            <img :src="this.pfp" class="rcorners1"/>
          </div>
          <div class="col-lg py-3 test">
            <p class="h3 text-white"> {{name}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="row mb1"> <!-- can prob remove one of the divs-->
              <ul class="nav flex-column">
                <li class="nav-item test1">
                  <router-link :to="'/portfolio' + '/' + this.uid" class="nav-link active" aria-current="page">Portfolio</router-link>
                </li>
                <li class="nav-item tabspacer">
                  <router-link :to="'/tradingcentre' + '/' + this.uid" class="nav-link active" aria-current="page">Trading Centre</router-link>
                </li>
                <!--
                 <li class="nav-item tabspacer">
                  <router-link :to="'/toplist' + '/' + this.uid" class="nav-link active" aria-current="page">Top List</router-link>
                </li>
                <li class="nav-item tabspacer">
                  <router-link :to="'/settings' + '/' + this.uid"  class="nav-link active" aria-current="page">Settings</router-link>
                </li>
                -->
              </ul>
            </div>
            <div class="row align-items-end">
              <button class="btn mt1 btn-light btn-sm" @click="handleLogout">Logout</button>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div id="view" class="clr3" v-if="this.loggedIn">
      <router-view/>
    </div>

    
    <div class="bluebox" v-if="!this.loggedIn">
      <h1 id="loginName">TuberTrader Inc.</h1>
    </div>
    <button @click="handleLogin" v-if="!this.loggedIn" class="btn btn-dark loginbutton ">Login/Signup</button>
    
  </div>
</template>


<script>
import { getAuth, signInWithPopup, GoogleAuthProvider, signOut } from "firebase/auth";
import { getFirestore, collection, doc, setDoc, getDoc, exists } from "firebase/firestore";
import axios from 'axios';
export default {
	data() {
		return {
      info: null, //api here
      loggedIn: false,
      auth: getAuth(),
      provider: new GoogleAuthProvider,
      uid: null,
      db: getFirestore(this.$app),
      networth: 0,
			lastDayLoggedIn: [], //[day, month, lastnetworth]
			stocks: [],
      name: '',
      pfp: ''
		}
	},
	methods: {
    handleLogin() {
      signInWithPopup(this.auth, this.provider)
      .then((result) => {
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        this.uid = result.user.uid;
        this.name = result.user.displayName;
        this.pfp = result.user.photoURL;
        console.log(this.uid + "11111")
        console.log(this.name + "sdasdasdasd")
        this.$loggedIn = true;
        this.loggedIn = true;
        this.$refs.mainView.setAttribute('id', 'loggedIn')
        this.$router.push('/portfolio' + '/' + this.uid)

        const docRef = doc(this.db, "users", this.uid);
		    getDoc(docRef).then((docSnap) => {
			  if (!docSnap.exists()) {
				  console.log("no uid doc yet")
				  setDoc(doc(this.db, "users", this.uid), {
					  networth: 20000,
					  lastDayLoggedIn: [new Date().getDate(), new Date().getMonth()+1, 0],
					  stocks: [],
            shares: [],
            bids: [],
            bidShares: [],
            asks: [],
            askShares: []

				  }).then(() => {
				  }) 
				  .catch((error) => {
					console.log(error.message)
				  });
			  } else {
				  console.log("havedata")
				  getDoc(docRef).then((docSnap) => {
					this.networth = docSnap.data().networth
					this.lastDayLoggedIn = docSnap.data().lastDayLoggedIn
					this.stocks = docSnap.data().stocks
				  }).catch((error) => {
					  console.log(error.message)
				  })
			}
				
		}).catch((error) => {
        	const errorMessage = error.message;
        	console.log(errorMessage)
      	});

    // ...
      }).catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        const email = error.customData.email;
        const credential = GoogleAuthProvider.credentialFromError(error);
        console.log(errorMessage)
    // ...
      });


    },
    handleLogout() {
      signOut(this.auth).then(() => {
        this.$user = null;
        this.$loggedIn = false;
        this.loggedIn = false;
        this.$refs.mainView.setAttribute('id', 'loggedOut')
        this.$router.push('/')
      }).catch((error) => {
        const errorMessage = error.message;
        console.log(errorMessage)
      });
    },
 
	},
  mounted() {
    axios
      .get('https://www.googleapis.com/youtube/v3/subscriptions') //accessing api here
      .then(response => (this.info = response))
      .catch(error => console.log(error))

    if (this.$route.params.uid) {
      console.log("routeDoesExist")
      this.loggedIn = true;
      this.$loggedIn = true;
    }
    console.log(this.$route)
    console.log(this.$loggedIn)
  }
}
</script>

<style scoped> 
  .rcorners1 {
    border-radius: 25px;
    margin-top: 10px;
    width: 80px;
    height: 80px;
  }
  .test{
    margin: auto
  }
  .test1{
    margin-top: 40px;
  }
  .tabspacer{
    margin-top: 10px;
  }
  #loggedIn {
    display: grid;
    height: 100vh;
    width: 100vw;
    grid-template-columns: 300px 1fr;
  }
  #loggedOut {
    display: grid;
    height: 100vh;
    width: 100vw;
    grid-template-rows: 150px 1fr;
  } 
  #view {
    
  } 
  .bg{
    background: #383;  
  }
  .userInfo{
    grid-template-columns: 10px 1fr !important;
    width: 100px !important; /*change this for the user styling*/
  }
  .mt1{
    width: 80% !important;
    margin: auto !important;
    margin-top: 90% !important;
  }
  .mb1{
    margin-bottom: 75% !important;
  }
  .bluebox{
    display: grid;
    background-color: #2A6A91;
    justify-items: center;
  }
  .loginbutton{
    height: 10% !important;
    width: 30% !important;
    margin: auto !important;
  }
  #nav {
    background-color: #292626;
    display: grid;
  }
  #navtop{
  }
  #navmiddle{
    display: grid;
    grid-template-rows: 25% 25% 25% 25%;
    justify-items: center;
  }
  #navbottom{
  }
  #loginName {
    color: white;
    align-self: center;
  }
  #nav a{
    color: white;
    text-decoration: none;
  }
  .clr3{
    background-color: #57AADE !important;
  }
</style>>


